<template>
<div class="w-header">
  <span class="logo" @click="toSystem"><img :src="groupInfo.imageUrl" /></span>
  <span class="title">{{ groupInfo.showName }}</span>
  <span class="exit">
    <el-popover placement="bottom-end" trigger="hover" popper-class="w-boss-open-menu">
      <div class="w-boss-menu-list">
        <ul class="position_relative">
          <li class="cursor_pointer">{{ username }}</li>
          <li class="cursor_pointer" @click="openUpdatePassword">修改密码</li>
          <li class="cursor_pointer" @click="signOut">退出</li>
        </ul>
      </div>
      <div slot="reference">
        <img src="/static/images/svolt/nanwang/exit.png" alt="">
      </div>
    </el-popover>
  </span>
  <span v-if="isMessage" class="header-icon" @click="messageCenter()">
    <!-- <el-badge :value="2" class="item" type="warning"> -->
      <img src="/static/images/svolt/nanwang/news.png" />
    <!-- </el-badge> -->
  </span>
  <div v-if="isTransactionDetails" class="header-button settlementBtn">
    <BtnBorder class="btnBorder-left"></BtnBorder>
    <div class="settlementBtnContent">
      <span class="menu-icon"><img src="/static/images/system/settlement.png" /></span>
      <span class="menu-text" @click="transactionDetails()">结算系统</span>
    </div>
    <BtnBorder class="settlement-right"></BtnBorder>
  </div>
  <div v-if="isPolicy" class="header-button controlStrategyBtn">
    <BtnBorder class="btnBorder-left"></BtnBorder>
    <div class="controlStrategyBtnContent">
      <span class="menu-icon"><img src="/static/images/system/controlStrategy.png" /></span>
      <span class="menu-text" @click="toPolicy()">控制策略优化系统</span>
    </div>
    <BtnBorder class="strategy-right"></BtnBorder>
  </div>
  <UpdatePassword :show="dlgshow" @close="closeDlg" ref="up"></UpdatePassword>
</div>
</template>

<script>
import {
  removeToken,
  getInfo
} from '@/utils/auth';
import USERAPI from '@/api/user';
import BtnBorder from './headerBtnBorder.vue';
import UpdatePassword from '@/views/svolt/project/components/nanwang/updatePassword'
export default {
  props: {
    path: {
      type: String
    }
  },
  data() {
    return {
      dlgshow:false,
      username: '',
      groupInfo: {},
      times: '', // 具体时间
      dates: '', // 具体日期
      weeks: '', // 具体星期几
      isIntellectDevOps: false,
      isWorkOrder: false,
      isKnowledgeGraph: false,
      isMessage: false,
      isTransactionDetails: false,
      isPolicy: false,
      platformResources: []
    };
  },
  components: {
    BtnBorder,
    UpdatePassword
  },
  methods: {
    closeDlg(f){
      this.dlgshow = false
      this.$refs['up'].clear()
      if(f==true){
        this.signOut()
      }
    },
    openUpdatePassword(){
      this.dlgshow = true
    },
    //初始数据
    init() {
      let self = this;
      let tempAuth = localStorage.getItem('ActiveModule');
      if (tempAuth && (this.$route.name == 'Svolt' || this.$route.name == 'workOrder' || this.$route.name == 'knowledgeGraph' || this.$route.name == 'transactionDetails' || this.$route.name == 'messageCenter')) {
        let json = JSON.parse(tempAuth);
        json.item.forEach(item => {
          if (item.resourceId == '30167') {
            self.isIntellectDevOps = true;
            self.isWorkOrder = true;
          }
          if (item.resourceId == '225') {
            self.isIntellectDevOps = true;
            self.isKnowledgeGraph = true;
          }
          if (item.resourceId == '30254') {
            self.isMessage = true;
          }
          if (item.resourceId == '360103') {
            self.isTransactionDetails = true;
          }
          if (item.resourceId == '60105') {
            self.isPolicy = true;
          }
        });
        // this.isTransactionDetails = true;
        // this.isPolicy = true;
      }
    },
    toSystem() {
      if (this.platformResources.length > 1) {
        let path = this.path ? this.path : '/system';
        this.$router.push({
          path: path
        });
      } else {
        return false;
      }
    },
    //退出登录
    signOut() {
      USERAPI.logout().then(res => {
        removeToken();
        this.$router.push({
          path: '/login'
        });
      });
    },
    currentTime() {
      setInterval(this.formatDate, 1000);
    },
    formatDate() {
      let date = new Date();
      let year = date.getFullYear(); // 年
      let month = date.getMonth() + 1; // 月
      month = month < 10 ? '0' + month : month; // 如果只有一位，则前面补零
      let day = date.getDate(); // 日
      day = day < 10 ? '0' + day : day; // 如果只有一位，则前面补零
      let week = date.getDay(); // 星期
      let weekArr = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
      let hour = date.getHours(); // 时
      hour = hour < 10 ? '0' + hour : hour; // 如果只有一位，则前面补零
      let minute = date.getMinutes(); // 分
      minute = minute < 10 ? '0' + minute : minute; // 如果只有一位，则前面补零
      let second = date.getSeconds(); // 秒
      second = second < 10 ? '0' + second : second; // 如果只有一位，则前面补零
      this.times = `${hour}:${minute}:${second}`;
      this.dates = `${year}/${month}/${day}`;
      this.weeks = `${weekArr[week]}`;
    },
    handleCommand(command) {
      let path = '/' + command;
      this.$router.push({
        path: path
      });
    },
    //工单管理
    workOrderBtn() {
      this.$router.push({
        path: '/workOrder'
      });
    },
    //知识图谱
    knowledgeGraphBtn() {
      this.$router.push({
        path: '/knowledgeGraph'
      });
    },
    //结算系统
    transactionDetails() {
      this.$router.push({
        path: '/transactionDetails'
      });
    },
    //控制策略优化
    toPolicy() {
      this.$router.push({
        path: '/svolt/project/policy'
      });
    },
    //消息中心
    messageCenter() {
      this.$router.push({
        path: '/messageCenter'
      });
    }
  },
  created() {
    let self = this;
    this.$nextTick(function () {
      let info = JSON.parse(getInfo());
      if (info) {
        self.username = info.user.username;
        self.groupInfo = info.groupInfo;
        self.platformResources = info.platformResources;
        document.title = self.groupInfo.groupName;
      }
    });
  },
  mounted() {
    // 初始化
    this.init();
    this.currentTime();
  },
  beforeDestroy() {
    if (this.formatDate) {
      clearInterval(this.formatDate); // 在Vue实例销毁前，清除时间定时器
    }
  }
};
</script>

<style lang="scss" scoped>
.w-header {
  height: 70px;
  line-height: 70px;
  background: url('/static/images/svolt/nanwang/header-bj-1920.png') no-repeat;
  background-size: 100% 100%;

  .logo {
    height: 70px;
    height: 70px;
    float: left;
    margin-left: 20px;
    margin-top: -7px;

    img {
      // width: 92px;
      height: 44px;
    }

    &:hover {
      cursor: pointer;
    }
  }

  .title {
    height: 70px;
    line-height: 70px;
    // float: left;
    // margin-left: 10px;
    font-size: 30px;
    font-family: 'YouSheBiaoTiHei';
    // font-family: 'FZDHTJW--GB1-0, FZDHTJW--GB1';
    font-weight: normal;
    color: #fff;
    // background-image: -webkit-linear-gradient(bottom, #e6fef9, #90cfff);
    -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  .header-icon,
  .header-button {
    float: right;
    // height: 60px;
    line-height: 60px;
  }

  // .header-icon {
  //   cursor: pointer;
  //   width: 24px;
  //   margin-right: 15px;

  //   .el-badge {
  //     color: #fff;
  //     width: 24px;
  //   }

  //   .item {
  //     margin-right: 40px;
  //   }

  //   >>> .el-badge__content.is-fixed {
  //     transform: translateY(50%) translateX(75%) !important;
  //   }

  //   img {
  //     width: 16px;
  //   }
  // }

  .header-icon {
    cursor: pointer;
    width: 24px;
    float: right;
    line-height: 55px;
    margin-right: 10px;

    .el-badge {
      color: #fff;
      width: 24px;
    }

    .item {
      margin-right: 40px;
    }

    >>> .el-badge__content.is-fixed {
      transform: translateY(50%) translateX(75%) !important;
    }

    img {
      width: 16px;
    }
  }

  .exit {
    float: right;
    line-height: 55px;
    margin-right: 20px;

    img {
      width: 16px;
      height: 17px;
    }

    &:hover {
      cursor: pointer;
    }
  }

  .header-button {
    cursor: pointer;

    &:hover {
      .menu-text {
        color: #1060C4;
      }
    }
  }

  .settlementBtn {
    width: 110px;
    height: 30px;
    line-height: 30px;
    margin-top: 15px;
    margin-right: 20px;
    background: linear-gradient(180deg, rgba(91, 175, 255, 0.32) 0%, rgba(255, 255, 255, 0) 42%, rgba(129, 198, 255, 0.2900) 100%);
    border: 1px solid #528EEA;
    text-align: center;
  }

  .controlStrategyBtn {
    width: 170px;
    height: 30px;
    float: right;
    line-height: 30px;
    margin-top: 15px;
    margin-right: 20px;
    background: linear-gradient(180deg, rgba(91, 175, 255, 0.32) 0%, rgba(255, 255, 255, 0) 42%, rgba(129, 198, 255, 0.2900) 100%);
    border: 1px solid #528EEA;
    text-align: center;
  }

  .menu-text {
    color: #4975D9;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
  }

  .menu-icon {

    img {
      width: 17px;
      height: 17px;
      margin-top: -5px;
    }
  }

  .btnBorder-left {
    float: left;
    margin-left: -3px;
  }

  .controlStrategyBtnContent {
    float: left;
    width: 166px;
  }

  .settlementBtnContent {
    float: left;
    width: 106px;
  }

  .strategy-right {
    float: left;
    margin-left: 166px;
  }

  .settlement-right {
    float: left;
    margin-left: 106px;
  }
}
</style>
<style lang="scss">
.el-popover.w-boss-open-menu {
  background: rgba(0, 98, 202, 0.9) !important;
  border: 1px solid #85d5ff;
  color: #fff;
  width: 120px;
  // height: 70px;
  line-height: 25px;
  padding-left: 10px !important;
  text-align: left;

  .popper__arrow {
    display: none;
  }
}

.el-popover.el-popper.w-boss-open-menu {
  border-color: #85d5ff;
  margin-top: -10px;
}

.w-boss-menu-list li:hover,
.w-boss-menu-list li:active {
  color: #19cae4;
}
</style>



// WEBPACK FOOTER //
// src/views/login/components/w-header.vue